/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const EarthSystems = ({ color = 'primary', aspectRatio = '1332/171', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="EarthSystems" aspectRatio={aspectRatio} color={color} {...rest} />;

export { EarthSystems, EarthSystems as default };
